<app-input-text
  [label]="label"
  [value]="value"
  [errorMessage]="errorMessage"
  placeholder="例) 1111.pic.frimo"
  (keyup)="checkProductCd($event)"
  (change)="checkProductCd($event)"
></app-input-text>
